export const calculatorFinancialApplicationFieldOptions = [
    {value: "term_of_the_loan", label: "Okres kredytu (lata)"},
    {value: "property_price", label: "Cena nieruchomości (PLN)"},
    {value: "own_contribution", label: "Wkład własny (PLN)"},
    {value: "contribution_percent", label: "Wkład własny (%)"},
    {value: "credit_amount", label: "Kwota kredytu (PLN)"},
    {value: "average_earnings", label: "Średnie miesięczne zarobki (PLN)"},
    {value: "income", label: "Dochód (PLN)"},
    {value: "region", label: "Region (id)"},
    {value: "bank", label: "Bank"},
    {value: "mortgage_offer_name", label: "Nazwa oferty kredytowej"},
    {value: "age", label: "Wiek najstarszego kredytobiorcy (lata)"},
    {value: "applicants_count", label: "Liczba wnioskodawców"},
    {value: "property_type", label: "Rodzaj nieruchomości"},
    {value: "monthly_household_spendings", label: "Comiesięczne wydatki gospodarstwa (PLN)"},
    {value: "other_loans_monthly_payments", label: "Raty innych zobowiązań (PLN)"}
] as const;
export const calculatorFinancialApplicationFieldOptions = [
    {value: "term_of_the_loan", label: "Okres kredytu (lata)"},
    {value: "property_price", label: "Cena nieruchomości (PLN)"},
    {value: "own_contribution", label: "Wkład własny (PLN)"},
    {value: "contribution_percent", label: "Wkład własny (%)"},
    {value: "credit_amount", label: "Kwota kredytu (PLN)"},
    {value: "average_earnings", label: "Średnie miesięczne zarobki (PLN)"},
    {value: "income", label: "Dochód (PLN)"},
    {value: "region", label: "Region (id)"},
    {value: "bank", label: "Bank"},
    {value: "mortgage_offer_name", label: "Nazwa oferty kredytowej"},
    {value: "age", label: "Wiek najstarszego kredytobiorcy (lata)"},
    {value: "applicants_count", label: "Liczba wnioskodawców"},
    {value: "property_type", label: "Rodzaj nieruchomości"},
    {value: "monthly_household_spendings", label: "Comiesięczne wydatki gospodarstwa (PLN)"},
    {value: "other_loans_monthly_payments", label: "Raty innych zobowiązań (PLN)"}
] as const;
